<template>
    <div id="heasers">
        <div class="header-wrap">
            <div class="header">
                <span class="left"
                      @click="goBack"><i class="icon-fanhui"></i></span>
                <div class="ellipsis">{{title}}</div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    name: 'HeaderTop',
    props: ['title', 'is_finish'],
    data () {
        return {

        }
    },
    created () {

    },
    methods: {
        goBack () {
            if (this.is_finish) {
                //app下退出应用，h5返回首页
                if(this.inApp){
                     this.appFunction("ys_finish");
                }else{
                    this.$router.replace('/');
                }
               
            } else {
                this.$router.go(-1);
            }
        }
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.header-wrap .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    height: $h-header;
    line-height: $h-header;
    color: #fff;
    font-size: 34px / $ppr;
    text-align: center;
    background: #5e89ef;
    .icon-fanhui {
        display: block;
        width: 76px / $ppr;
        height: $h-header;
        background-image: url("./img/back.png");
        background-position: center;
        background-size: 18px / $ppr 34px / $ppr;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    .ellipsis {
        width: 520px / $ppr;
        margin: 0 auto;
    }
}
</style>
